<template>
  <div class="table-container">
    <public-table
      v-loading="Loading"
      :column="column"
      :PageInfo="listQuery"
      :searchItems="searchItems"
      :enableSearch="true"
      @handlePaginationChange="fetchAppCustomerList"
      :tableData="customers"
    >
      <!-- <template v-slot:createTime="{row}">{{ row.createTime ? timetrans(row.createTime) : "-" }}</template> -->
      <template v-slot:createTime="{ row }">{{
        row.createTime ? timetrans(row.createTime) : "-"
      }}</template>
    </public-table>
  </div>
</template>
<script>
import { timetrans } from '@/utils/validate';

import { fetchAppCustomers } from '@/api/app';
import { errorHandle } from '../../../../utils/error';
export default {
  name: 'AppCustomerList',
  props: {
    appDetail: {
      type: Object
    },
    marketID: {
      type: String
    }
  },
  data() {
    return {
      listQuery: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      Loading: true,
      appID: this.$route.params.appID,
      timetrans,
      customers: [],
      showEditVersion: false,
      editVersion: {},
      searchItems: [
        {
          label: '客户名称',
          value: '',
          name: 'query',
          type: 'input'
        }
      ],
      column: [
        {
          prop: 'customerName',
          label: '客户名称'
        },
        {
          prop: 'createTime',
          label: '交付时间',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.fetchAppCustomerList();
  },
  methods: {
    fetchAppCustomerList(params) {
      if (params) {
        this.listQuery = Object.assign(this.listQuery, params);
      }
      this.listQuery.marketID = this.marketID;
      this.listQuery.appID = this.appID;
      fetchAppCustomers(this.listQuery)
        .then((res) => {
          this.Loading = false;
          this.customers = res.customers;
          this.listQuery.tatol = res.total;
        })
        .catch((err) => {
          this.Loading = false;
          if (err.code == 404) {
            this.$router.push({
              name: 'appManage'
            });
            return;
          }
          errorHandle(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/appCustomer.vue